const mainReducer = (state, action) => {
  switch (action.type) {
    case 'searchRequest': {
      return { ...state, loading: true, options: [] };
    }
    case 'searchSuccess': {
      return { ...state, loading: false, hasErrored: false, options: action.data };
    }
    case 'searchStateRequest': {
      return { ...state, loading: true, states: [] };
    }
    case 'searchStateSuccess': {
      return { ...state, loading: false, hasErrored: false, states: action.data };
    }
    case 'submitRequest': {
      return { ...state, loading: true };
    }
    case 'submitSuccess': {
      return { ...state, loading: false, hasErrored: false, options: action.data };
    }
    case 'updateSelectedProvider': {
      return { ...state, confirmedProvider: action.data };
    }
    case 'updateFormStep': {
      return { ...state, formStep: action.data };
    }
    case 'setStateEmail': {
      return { ...state, email: action.data };
    }
    case 'setStatePassword': {
      return { ...state, password: action.data };
    }
    case 'errored': {
      return { ...state, hasErrored: true, error: action.error, loading: false };
    }
    case 'resetError': {
      return { ...state, hasErrored: false, error: null };
    }
  }
};
export default mainReducer;
